/**
 * Gestion des icônes
 * @url https://github.com/feathericons/feather
 */

import Feather from 'feather-icons';


/**
 * Custom elements
 */
// Shopping cart item
const shopingCartListItem = document.querySelector('.cart a');
if (shopingCartListItem) {
  const shopingCartIcon = document.createElement('i');
  shopingCartIcon.setAttribute('data-feather', 'shopping-cart');
  shopingCartListItem.appendChild(shopingCartIcon);
}

// Autocomplete Magnifier
const autoCompleteItem = document.querySelector('.dgwt-wcas-sf-wrapp');
if (autoCompleteItem) {
  const autoCompleteMagnifierIcon = document.createElement('i');
  autoCompleteMagnifierIcon.setAttribute('data-feather', 'search');
  autoCompleteItem.appendChild(autoCompleteMagnifierIcon);
}


/**
 * Global replacement
 * Replace all elements `data-feather="circle"` into svg icon
 */
Feather.replace();
